module.exports = __webpack_public_path__ + "img/seo.db003d56.png";